import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { MsgTemplate } from './msg-template';
import { SharedService } from './../_shared/shared.service';
import {MsgTemplateData} from '@app/_components/msg-template/msg-template-data';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class MsgTemplateService {

	statuses: any = [
		{ value: 0, name: 'Inactive' },
		{ value: 1, name: 'Active' },
		{ value: 2, name: 'Backend' },
		{ value: 3, name: 'Header' },
	];
	communicationMediums: any = [
		{ value: 1, name: 'Email' },
		{ value: 2, name: 'SMS' },
		{ value: 5, name: 'Email & SMS' },
	];
	msgTemplates: any;
	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'msgTemplates';
	urlEndpointAll = 'msgTemplatesAll';

	add(msgTemplate: MsgTemplate): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(msgTemplate));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, msgTemplate);
	}

	update(msgTemplate: MsgTemplate): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, msgTemplate);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`);
	}
	findAllWithoutPage(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpointAll}`);
	}
	fetchAllTemplatesSummary(params: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/msgTemplatesSummary`, { params });
	}
  findAllForDropDown(msgTemplate: MsgTemplate): Observable<ApiResponse> {
    let filters  = {'status': {'value': msgTemplate?.status, 'matchMode': 'in'}, 'msgAudience': {'value': msgTemplate?.msgAudience, 'matchMode': 'in'}};
    let multiSortMeta = [{'field': 'createDate', 'order': 0}];
    let params = this.sharedService.prepareParamsFromPrimeNgDataTable(0, 10000, 'name', 1 , multiSortMeta, null, filters);
    console.log('posting... ' + JSON.stringify(filters));
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));
  }

	fetchAllTemplates() {
		if (!this.msgTemplates || this.msgTemplates === undefined || this.msgTemplates.length < 1) {
			try {
				this.findAllWithoutPage()
					.subscribe(
						res => {
							console.log('employee Profiles: ' + JSON.stringify(res));
							this.msgTemplates = res.data.msgTemplates;
							return this.msgTemplates;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			return (this.msgTemplates);
		}
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(msgTemplateId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${msgTemplateId}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
  getTemplateVars(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/template-vars`).pipe(retry({ count: 2, delay: 1500 }));
  }

  mergeTemplateBytopic(id: number, topic: number, topicId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/mergeTemplate/${id}/${topic}/${topicId}`).pipe(retry({ count: 2, delay: 1500 }));
  }
	mergeTemplateBatch(body): Observable<ApiResponse[]> {
		return this.http.post<ApiResponse[]>(`${environment.apiUrl}/${this.urlEndpoint}/mergeTemplate`,body);
	}
  mergeDataIntoTemplate(template: any, templateData: MsgTemplateData) {
    if ( !template || !templateData){
      return '';
    }
    template = template.replaceAll('{{fullName}}', templateData.fullName);
    template = template.replaceAll('{{resortName}}', templateData.resortName);
    template = template.replaceAll('{{firstName}}', templateData.firstName);
    template = template.replaceAll('{{adrDevelopmentName}}', templateData.adrDevelopmentName);
    template = template.replaceAll('{{publicWebsite}}', templateData.publicWebsite);
    template = template.replaceAll('{{unsubscribe}}', templateData.unsubscribe);
    template = template.replaceAll('{{confirmationNumber}}', templateData.confirmationNumber);
    template = template.replaceAll('{{reservationId}}', templateData.reservationId);
    template = template.replaceAll('{{emailAddress}}', templateData.emailAddress);
    template = template.replaceAll('{{mobilePhone}}', templateData.mobilePhone);
    template = template.replaceAll('{{checkInDateTime}}', moment(templateData.checkInDateTime).toDate() + '');
    template = template.replaceAll('{{checkOutDateTime}}',  moment(templateData.checkOutDateTime).toDate() + '');
    return template;
  }
}
